// AccountingPage.jsx - Enhanced with tab navigation and refresh mechanism

import React, { useState } from "react";
import AccountingForm from "./AccountingForm";
import AccountingDashboard from "./AccountingDashboard";

export default function AccountingPage() {
  const [activeTab, setActiveTab] = useState("dashboard"); // "add" | "dashboard"
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Check role before rendering
  const userRole = localStorage.getItem("userRole");

  if (userRole !== "admin") {
    return (
      <div className="p-6 text-center">
        <h2 className="text-xl font-semibold text-red-600">❌ Access Denied</h2>
        <p className="text-gray-600 mt-1">Only admin can view accounting.</p>
      </div>
    );
  }

  // Trigger dashboard refresh when form saves successfully
  const handleSaveSuccess = () => {
    setRefreshTrigger(prev => prev + 1);
    // Optionally switch to dashboard tab
    setActiveTab("dashboard");
  };

  return (
    <div className="p-4 sm:p-6 max-w-7xl mx-auto space-y-6">
      {/* Page Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
        <h2 className="text-2xl font-bold text-[#2D2F5E]">💼 Income & Expenditure</h2>
        <p className="text-sm text-[#2D2F5E] opacity-70 mt-1 sm:mt-0">
          Manage your business finances
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white rounded-lg shadow-sm border border-[#2D2F5E] border-opacity-20 overflow-hidden">
        <div className="flex border-b border-[#2D2F5E] border-opacity-20">
          <button
            onClick={() => setActiveTab("add")}
            className={`flex-1 px-6 py-3 font-medium transition ${
              activeTab === "add"
                ? "bg-[#2D2F5E] text-white"
                : "bg-[#F5E9D8] text-[#2D2F5E] hover:bg-[#E9DCC8]"
            }`}
          >
            ➕ Add Entry
          </button>
          <button
            onClick={() => setActiveTab("dashboard")}
            className={`flex-1 px-6 py-3 font-medium transition ${
              activeTab === "dashboard"
                ? "bg-[#2D2F5E] text-white"
                : "bg-[#F5E9D8] text-[#2D2F5E] hover:bg-[#E9DCC8]"
            }`}
          >
            📊 Dashboard & Reports
          </button>
        </div>

        {/* Tab Content */}
        <div className="p-5">
          {activeTab === "add" && (
            <AccountingForm onSaveSuccess={handleSaveSuccess} />
          )}

          {activeTab === "dashboard" && (
            <AccountingDashboard refreshTrigger={refreshTrigger} />
          )}
        </div>
      </div>

      {/* Help Text */}
      <div className="bg-[#F5E9D8] p-4 rounded-lg border border-[#2D2F5E] border-opacity-20">
        <h3 className="font-bold text-[#2D2F5E] mb-2">💡 Quick Tips</h3>
        <ul className="text-sm text-[#2D2F5E] space-y-1">
          <li>• <strong>Income:</strong> Track money received from clients and sales</li>
          <li>• <strong>Expenses:</strong> Record all business costs (ingredients, utilities, salaries)</li>
          <li>• <strong>Monthly Report:</strong> View category-wise breakdown and net balance</li>
          <li>• <strong>Link Deliveries:</strong> Connect income to specific delivery items (optional)</li>
          <li>• <strong>Export:</strong> Download reports as PDF or CSV for accounting</li>
        </ul>
      </div>
    </div>
  );
}